import React, { useState } from 'react';
import { Box, Button, DataTable } from '../../../../common/components';
import Select from 'react-select';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { getBrokerId, getOrganisationId, isOwner } from '../../../auth/redux/authActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { InternalButtonBar } from '../../../layout/components';
import selectTheme from '../../../../helpers/selectTheme';
import AsyncSelectMenu from '../../../../common/components/SelectMenu/AsyncSelectMenu';
import formatDate from '../../../../helpers/formatDate';
import { connect } from 'react-redux';

const UserList = ({ goTo, onApplyFilter, status }) => {
  const [userStatus, setUserStatus] = useState(status);
  const brokerId = getBrokerId();
  const organisationId = getOrganisationId();

  const handleRowClick = (row) => {
    goTo('/admin/users/' + row.id);
  };

  const handleSearchUpdate = (event) => {
    onApplyFilter('users', 'filter[search]', event.target.value);
  };

  const handleOrganisationFilterUpdate = (option) => {
    onApplyFilter('users', 'filter[organisation]', option ? option.value : '');
  };

  const handleUserStatusFilterUpdate = (option) => {
    onApplyFilter('users', 'filter[status]', option.value);
    setUserStatus(option.value);
  };
  return (
    <div>
      <Box>
        <Row>
          <Col sm={5}>
            <ControlLabel>Search</ControlLabel>
            <FormControl onChange={handleSearchUpdate} />
          </Col>

          {isOwner() && (
            <Col sm={5}>
              <ControlLabel>Organisation</ControlLabel>
              <AsyncSelectMenu
                url={'/organisations?'}
                optionValuePath={'id'}
                onChangeCallback={handleOrganisationFilterUpdate}
                isClearable
              />
            </Col>
          )}

          <Col sm={2}>
            <ControlLabel>Status</ControlLabel>
            <Select
              theme={(theme) => selectTheme(theme)}
              options={[
                { label: 'Pending', value: 'pending' },
                { label: 'Active', value: 'active' },
                { label: 'Inactive', value: 'inactive' },
              ]}
              isClearable
              onChange={handleUserStatusFilterUpdate}
            />
          </Col>
        </Row>
      </Box>

      <Box>
        <DataTable
          source="/users"
          name="users"
          showTotal
          onRowSelect={handleRowClick}
          autoFilters={
            userStatus ? [{ type: 'filter[status]', value: userStatus }] : undefined
          }
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="full_name">Name</TableHeaderColumn>

          <TableHeaderColumn dataField="email" dataSort width={'260px'}>
            Email
          </TableHeaderColumn>

          <TableHeaderColumn dataField="phone1" dataSort width={'260px'}>
            Phone
          </TableHeaderColumn>

          <TableHeaderColumn dataField="status" dataSort width={'100px'}>
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="created_at"
            dataFormat={formatDate}
            width={'180px'}
          >
            Created
          </TableHeaderColumn>
        </DataTable>

        {organisationId && brokerId && (
          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['user.create'],
                    button: (
                      <Button
                        link={true}
                        to={`/admin/users/new/${organisationId}/${brokerId}`}
                        className="pull-right"
                        bsStyle="primary"
                        rightIcon="user"
                        label="add a new user"
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        )}
      </Box>
    </div>
  );
};

export default connect(
  null,
  {
    goTo: push,
    onApplyFilter: applyFilter,
  },
)(UserList);
